module.exports = __webpack_public_path__ + "img/fake-user-9.fa0c4494.png";